/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationAdminUpdateGroupLocationTracking
 */
export interface OrganizationAdminUpdateGroupLocationTracking {
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminUpdateGroupLocationTracking
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminUpdateGroupLocationTracking
     */
    group_name: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationAdminUpdateGroupLocationTracking
     */
    allow_group_location_tracking: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrganizationAdminUpdateGroupLocationTracking
     */
    organization_azure_id: string;
}

/**
 * Check if a given object implements the OrganizationAdminUpdateGroupLocationTracking interface.
 */
export function instanceOfOrganizationAdminUpdateGroupLocationTracking(value: object): value is OrganizationAdminUpdateGroupLocationTracking {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('group_name' in value) || value['group_name'] === undefined) return false;
    if (!('allow_group_location_tracking' in value) || value['allow_group_location_tracking'] === undefined) return false;
    if (!('organization_azure_id' in value) || value['organization_azure_id'] === undefined) return false;
    return true;
}

export function OrganizationAdminUpdateGroupLocationTrackingFromJSON(json: any): OrganizationAdminUpdateGroupLocationTracking {
    return OrganizationAdminUpdateGroupLocationTrackingFromJSONTyped(json, false);
}

export function OrganizationAdminUpdateGroupLocationTrackingFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationAdminUpdateGroupLocationTracking {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'group_name': json['group_name'],
        'allow_group_location_tracking': json['allow_group_location_tracking'],
        'organization_azure_id': json['organization_azure_id'],
    };
}

export function OrganizationAdminUpdateGroupLocationTrackingToJSON(json: any): OrganizationAdminUpdateGroupLocationTracking {
    return OrganizationAdminUpdateGroupLocationTrackingToJSONTyped(json, false);
}

export function OrganizationAdminUpdateGroupLocationTrackingToJSONTyped(value?: OrganizationAdminUpdateGroupLocationTracking | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'group_name': value['group_name'],
        'allow_group_location_tracking': value['allow_group_location_tracking'],
        'organization_azure_id': value['organization_azure_id'],
    };
}

